import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardTitle,
  CardBody,
  Table,
  Spinner,
  Button,
} from 'reactstrap';
import { Link, useHistory } from 'react-router-dom';

import { getToko } from '../../actions/TokoAction';
import { DELETE_TOKO, GET_TOKEN } from 'utils';

import swal from 'sweetalert';
import axios from 'axios';
import jwt_decode from 'jwt-decode';
import { logOutUser } from 'actions/AuthAction';

export default function ListToko() {
  const dispatch = useDispatch();
  const history = useHistory();

  const { getTokoError, getTokoLoading, getTokoResult } = useSelector(
    (state) => state.TokoReducer
  );

  // auth

  const [token, setToken] = useState('');
  const [nama, setNama] = useState('');
  const [username, setUsername] = useState('');
  const [akses, setAkses] = useState('');
  const [expire, setExpire] = useState('');
  const [idAdmin, setIdAdmin] = useState('1');

  const refreshToken = async () => {
    try {
      const response = await axios.get(GET_TOKEN + '/token');
      setToken(response.data);
      const decoded = jwt_decode(response.data.accessToken);
      setNama(decoded.nama);
      setUsername(decoded.username);
      setAkses(decoded.akses.split(','));
      setExpire(decoded.exp);
      setIdAdmin(decoded.idAdmin);
    } catch (error) {
      if (error.response) {
        dispatch(logOutUser(history));
        history.push('/');
      }
    }
  };

  const axiosJWT = axios.create();

  axiosJWT.interceptors.request.use(
    async (config) => {
      const currentDate = new Date();
      if (expire * 1000 < currentDate.getTime()) {
        const response = await axios.get(GET_TOKEN + '/token');
        config.headers.Authorization = `Bearer ${response.data.accessToken}`;
        setToken(response.data.accessToken);
        const decoded = jwt_decode(response.data.accessToken);
        setNama(decoded.nama);
        setUsername(decoded.username);
        setAkses(decoded.akses);
        setIdAdmin(decoded.idAdmin);
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  //auth

  useEffect(() => {
    dispatch(getToko());
    refreshToken();
  }, []);

  const removeData = async (id) => {
    await axios.delete(DELETE_TOKO + `${id}`);
    swal('Sukses!', 'Toko berhasil dihapus', 'success');
    history.push('/admin');
    history.push('/admin/toko');
  };

  return (
    <div className='content'>
      <Row>
        <Col md='12'>
          <Card>
            <CardHeader>
              <CardTitle tag='h4'>List Toko</CardTitle>
              <Link
                to={'/admin/toko/tambah/' + idAdmin}
                className='btn btn-primary float-right'
              >
                Tambah Toko
              </Link>
            </CardHeader>
            <CardBody style={{ overflowX: 'auto' }}>
              <Table>
                <thead className='text-primary'>
                  <tr>
                    <th>Id</th>
                    <th>Foto</th>
                    <th>Toko</th>
                    <th>Pemilik</th>
                    <th>No HP</th>
                    <th>Alamat</th>
                    <th>Aksi</th>
                  </tr>
                </thead>

                <tbody>
                  {getTokoResult ? (
                    Object.keys(getTokoResult).map((key) => (
                      <tr key={key}>
                        <td>{getTokoResult[key].id}</td>
                        <td>
                          <img
                            src={getTokoResult[key].foto.split(',')[0]}
                            width='100'
                            alt={getTokoResult[key].toko}
                          />
                        </td>
                        <td>{getTokoResult[key].toko}</td>
                        <td>{getTokoResult[key].pemilik}</td>
                        <td>{getTokoResult[key].noHp} </td>
                        <td>{getTokoResult[key].alamat} </td>
                        <td>
                          <Link
                            className='btn btn-warning'
                            to={
                              '/admin/toko/edit/' +
                              getTokoResult[key].id +
                              ',' +
                              idAdmin
                            }
                          >
                            <i className='nc-icon nc-ruler-pencil'></i> Edit
                          </Link>
                        </td>
                        <td>
                          <Button
                            color='danger'
                            className='ml-2'
                            onClick={() => removeData(getTokoResult[key].id)}
                          >
                            <i className='nc-icon nc-basket'></i> Hapus
                          </Button>
                        </td>
                      </tr>
                    ))
                  ) : getTokoLoading ? (
                    <tr>
                      <td colSpan='6' align='center'>
                        <Spinner color='primary' />
                      </td>
                    </tr>
                  ) : getTokoError ? (
                    <tr>
                      <td colSpan='6' align='center'>
                        {getTokoError}
                      </td>
                    </tr>
                  ) : (
                    <tr>
                      <td colSpan='6' align='center'>
                        Data Kosong
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
}
